import React, { useEffect, useState, useContext } from 'react';
import { useSelector } from 'react-redux'; // Import useSelector hook from Redux
import { selectAppBalances } from '../store/appSlice'; // Import the selector to get the levelingPotionBalance
import { SolanaContext } from '../contexts/solanaContext';
import BackButton from './BackButton';
import AntInfoPopup from './AntInfoPopup';
import useSolanaWeb3 from '../hooks/useSolanaWeb3';
import { fetchNFTsOnchain } from '../apis';


function UseLevelingPotion({ goBack, changeActiveComponent }) {
  const appBalances = useSelector(selectAppBalances); // Use useSelector to access the appBalances from Redux store
  const levelingPotionBalance = appBalances.levelingPotionBalance; // Access the specific balance
  const [selectedAnt, setSelectedAnt] = useState(null);
  const [selectedSection, setSelectedSection] = useState(null);
  // const antNFTs = staticAntNFTs; // Using static data
  const [antNFTs, setNfts] = useState([]); // State to hold fetched NFTs
  const { wallet } = useContext(SolanaContext); // Use SolanaContext to access the wallet
  const { fectchANTStateData } = useSolanaWeb3();

  useEffect(() => {
    const fetchNFTs = async (walletAddress) => {
      try {
        // const response = await fetch('https://backend.kingdomofants.app/api/fetch-nfts', {
        
        const nfts = await fetchNFTsOnchain(walletAddress, 0)

        let nonLeveledNfts = [];
        for (const nft of nfts) {
          const state = await fectchANTStateData(nft.mint);
          if (!state.boolLeveled) {
            nonLeveledNfts.push({
              mint: nft.mint,
              metadata: nft.metadata,
              state: state,
            });
          }
        }

        console.log(nonLeveledNfts)
        setNfts(nonLeveledNfts);
      } catch (error) {
        console.error('Failed to fetch NFTs:', error);
      }
    };
    if (wallet.connected && wallet.publicKey) {
      fetchNFTs(wallet.publicKey.toString());
    }
  }, [wallet.connected, wallet.publicKey]);

  const handleANTItemClick = (antInfo) => {
    setSelectedAnt(antInfo);
  };

  useEffect(()=>{
    console.log('loaded uselevelingpotino component', levelingPotionBalance)
  },[])

  return (
    <section id="nestwars">
      <div className="newui-container">
      <div className="platform-container">
        <div className="inventory-container" id="select-ants">
          <div className="inventory-container-left" id="select-ants-container">
            <div className="inventory-items">
              {antNFTs.length > 0 && antNFTs.map((ant, index) => {
                // Determine class for background based on the name of the NFT
                const bgClass = ant.metadata.name.toLowerCase().includes("premium") ? "item-premium" : "item-basic";
                return (
                  <div key={index} className={`inventory-item-use ${bgClass}`} onClick={() => handleANTItemClick(ant)}>
                    <img src={ant.metadata.image} alt="Ant" />
                    <div className="inventory-item-texts" id="potionuse">
                      <p className="inventory-text">WORKER ANT</p>
                    <p className="inventory-level-text-use">LVL:</p><p>{Number(ant.state.level)}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        {selectedAnt && <AntInfoPopup levelingPotionBalance={levelingPotionBalance} antInfo={selectedAnt} onClose={() => setSelectedAnt(null)} />}
      </div>
      </div>
    </section>
  );
}

export default UseLevelingPotion;